export const VIDEO_STORY_MEDIA_STATE_CLIENT_INFO = 'VideoStoryPlaybackInterface.v1_0.VideoStoryMediaStateClientInformation';
